import { IInitialContextResult } from "../services/contextService";
import IFormType from "../interfaces/IFormType";


export const FormTypeMapper = {
    apiToDomain: (api: IInitialContextResult["lomakkeet"][0]): IFormType => ({
        id: api.id,
        guid: api.guid,
        name: api.nimi,
        category: api.kategoria,
        formDefinition: api.lomakemaaritys,
        workflow: api.tyonkulku,
        referenceName: api.viitenimi
    }),
};


export default FormTypeMapper

